import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
} from "@mui/material";
const getValuePoints = (weight, topPct) => {
  return Math.round((100 - topPct * 100) * weight * 100) / 100;
};
export default function UserLevelTable(props) {
  console.log("UserLevelTable props -----", props);
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Weight</TableCell>
            <TableCell>Attribute</TableCell>
            <TableCell>Rank</TableCell>
            <TableCell>Points</TableCell>
            <TableCell>Top %</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow sx={{ backgroundColor: "#808080" }}>
            <TableCell component="th" scope="row">
              {props?.level?.weight}
            </TableCell>
            <TableCell component="th" scope="row">
              Overall
            </TableCell>
            <TableCell component="th" scope="row">
              {props?.level?.rank}
            </TableCell>
            <TableCell component="th" scope="row">
              {Math.round(props?.level?.points)}
            </TableCell>
            <TableCell component="th" scope="row">
              {`${props?.level?.topPct * 100} %`}
            </TableCell>
          </TableRow>
          {props?.rows?.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                {`${Math.round(row.weight * 100)} %`}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.rank}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.points}
              </TableCell>
              <TableCell component="th" scope="row">
                {`${Math.round(row.topPct * 100)} %`}{" "}
                {`(${getValuePoints(row.weight, row.topPct)})`}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
